import React, { useContext } from 'react';

interface TransferMoneyContext {
  clientId: string;
  accountId: string;
  accountName: string;
  managedAccountId: string;
}

export const TransferMoneyContext = React.createContext<TransferMoneyContext>({
  clientId: '',
  accountId: '',
  accountName: '',
  managedAccountId: '',
});

export const useTransferMoneyContext = () => {
  return useContext(TransferMoneyContext);
};
